import { type Writable, writable } from 'svelte/store';

export const isAuthenticated = writable(false);
export const user: Writable<User> = writable(null);
export const pending = writable(true);
